import { t } from '@lingui/core/macro';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { SearchStringFilter } from './SearchStringFilter';
import { useGetUsers } from './useGetUsers/useGetUsers';
export const projectUserMembersFilterLabel = () => t({ message: 'Members (users)', comment: 'Insights filter: Members (users)' });
export const ProjectUserMembersFilter = withFilterErrorBoundary(() => {
    const { data, error, loading } = useGetUsers();
    const disabled = Boolean(loading || error);
    return (<SearchStringFilter name="metadataProjectMembersCombinedUserIds" items={data} label={projectUserMembersFilterLabel()} loading={disabled}/>);
});
